import i18n from "@/i18n";

export const fontFields = [
    {
        key: "status",
        label: ""
    },
    {
        key: "technicalName",
        label: i18n.t("fonts.technicalName"),
        tdClass: "td-sm",
        sortable: true
    },
    {
        key: "displayName",
        label: i18n.t("fonts.displayName"),
        tdClass: "td-sm",
        sortable: true
    },
    {
        key: "type",
        label: i18n.t("fonts.type"),
        tdClass: "td-sm",
        sortable: true
    },
    {
        key: "actions",
        label: ""
    }];
